import React from "react"
import { Pagination, PaginationItem, PaginationLink } from "reactstrap"

const Paginacion = ({
  paginaActual = 1,
  totalPaginas = 1,
  onPaginaCambio = () => {},
  className = "justify-content-start",
}) => {
  const handlePageChange = nuevaPagina => {
    if (nuevaPagina >= 1 && nuevaPagina <= totalPaginas) {
      onPaginaCambio(nuevaPagina)
    }
  }

  return (
    <Pagination aria-label="Navegación de páginas" listClassName={className}>
      {/* Ir a la primera página */}
      <PaginationItem disabled={paginaActual === 1}>
        <PaginationLink onClick={() => handlePageChange(1)}>
          <i className="mdi mdi-chevron-double-left" />
        </PaginationLink>
      </PaginationItem>

      {/* Retroceder una página */}
      <PaginationItem disabled={paginaActual === 1}>
        <PaginationLink onClick={() => handlePageChange(paginaActual - 1)}>
          <i className="mdi mdi-chevron-left" />
        </PaginationLink>
      </PaginationItem>

      {/* Estado actual de la paginación */}
      <PaginationItem disabled>
        <PaginationLink href="#">
          {`${paginaActual} de ${totalPaginas}`}
        </PaginationLink>
      </PaginationItem>

      {/* Avanzar una página */}
      <PaginationItem disabled={paginaActual === totalPaginas}>
        <PaginationLink onClick={() => handlePageChange(paginaActual + 1)}>
          <i className="mdi mdi-chevron-right" />
        </PaginationLink>
      </PaginationItem>

      {/* Ir a la última página */}
      <PaginationItem disabled={paginaActual === totalPaginas}>
        <PaginationLink onClick={() => handlePageChange(totalPaginas)}>
          <i className="mdi mdi-chevron-double-right" />
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  )
}

export default Paginacion
